import { gql } from "@apollo/client";

const CREATE_ZONE = gql`
  mutation createZone($zone: ZoneCreateInput!) {
    createZone(zone: $zone) {
      success
      message
      zone {
        id
      }
    }
  }
`;

export { CREATE_ZONE };
